import { Component, CUSTOM_ELEMENTS_SCHEMA, HostListener, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { IBannerData } from 'src/app/models/banner.model';
import { isPlatformBrowser } from '@angular/common';
import { register } from 'swiper/element/bundle';
import { LazyLoadImageModule } from 'ng-lazyload-image';

register();


@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  standalone: true,
  imports: [LazyLoadImageModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BannerComponent implements OnInit {

  @Input() banners: IBannerData[] = [];
  public bannerHeight: number;
  public isMobile = false;
  public customStyle: string;
  @HostListener('window:resize', ['$event'])
  onResize(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.bannerHeight = window.innerWidth <= 800 ? 220 : 256;
      this.isMobile = window.innerWidth <= 800;
      this.customStyle = this.isMobile ? '--swiper-pagination-color: #7ec543; --swiper-pagination-bullet-size: 15px;' : '--swiper-pagination-color: #7ec543; --swiper-pagination-bullet-size: 10px;';
    }
  }

  constructor(@Inject(PLATFORM_ID) private platformId: string,) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.bannerHeight = window.innerWidth <= 800 ? 220 : 256;
      this.isMobile = window.innerWidth <= 800;
      this.customStyle = '--swiper-pagination-color: #7ec543; --swiper-pagination-bullet-size: 10px;';

    }
  }

  public trackByBanner(index: number): number {
    return index;
  }

  public goLink(link: string): void {
    if (isPlatformBrowser(this.platformId)) {
      window.open(link);
    }
  }

}
